export default __webpack_public_path__ + "static/TabloidsNotFound-eb293a7a176af0fc1eb7bb68801a9877.png";